import comp from "./RemoveSubjectModal.js";
export default comp;
